var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3866 8.02876C10.3866 9.34876 9.31995 10.4154 7.99995 10.4154C6.67995 10.4154 5.61328 9.34876 5.61328 8.02876C5.61328 6.70876 6.67995 5.64209 7.99995 5.64209C9.31995 5.64209 10.3866 6.70876 10.3866 8.02876Z",
    stroke: "#A4A1B3",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9999 13.5421C10.3532 13.5421 12.5466 12.1555 14.0732 9.75546C14.6732 8.81546 14.6732 7.23546 14.0732 6.29546C12.5466 3.89546 10.3532 2.50879 7.9999 2.50879C5.64656 2.50879 3.45323 3.89546 1.92656 6.29546C1.32656 7.23546 1.32656 8.81546 1.92656 9.75546C3.45323 12.1555 5.64656 13.5421 7.9999 13.5421Z",
    stroke: "#A4A1B3",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEye);
export default __webpack_public_path__ + "static/media/closeEye.570cbe0a5453f126bd2bb4776cc0e662.svg";
export { ForwardRef as ReactComponent };